module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_eight-85539f106b83ff101abc035d67da981f.webp";